export const deleteSetTexts = {
    title: "activation.settings.delete.title",
    body: "activation.settings.delete.body",
    buttonText: "activation.settings.delete.button.text",
};
